import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["resetable", "className", "style", "disabled", "onReset", "children"];
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

var BtnReset = function BtnReset(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14.272 4.242a8.461 8.461 0 0 0-2.277-1.55V0l-.746.423c-1.218.69-3.92 2.506-4.033 2.583l-.63.424.638.41c.113.074 2.796 1.805 4.038 2.46l.733.387V3.819c.57.31 1.104.688 1.588 1.147 3.044 2.894 3.23 7.792.413 10.92-1.363 1.513-3.217 2.389-5.219 2.466-2.006.078-3.904-.648-5.37-2.043C.363 13.416.178 8.518 2.994 5.39l-.743-.668c-3.175 3.526-2.966 9.05.466 12.313 1.585 1.506 3.622 2.324 5.77 2.324.11 0 .219-.002.329-.007 2.275-.088 4.378-1.081 5.922-2.796 3.176-3.526 2.967-9.05-.466-12.313zm-3.277.761a91.787 91.787 0 0 1-2.586-1.591c.67-.444 1.741-1.149 2.586-1.672v3.263z"
  }));
};

BtnReset.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16.9898434 19.3579102"
};
import { blueGray100 } from "../theme/colors";
import createStyles from "../createStyles";
import Button from "../Button";
import Row from "../Layout/Row";
import Icon from "../Icon";
export var useStyles = createStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      width: '100%',
      height: '100%'
    },
    resetButton: {
      flex: '0 0 46px',
      height: '100%',
      color: theme.palette.secondary["default"],
      borderRadius: 0,
      transition: theme.transition.create('color'),
      borderLeft: "solid 1px ".concat(theme.palette.border),
      '&:hover': {
        color: theme.palette.primary["default"]
      }
    },
    resetButtonDisabled: {
      color: blueGray100,
      '&:hover': {
        color: blueGray100
      }
    }
  };
});
var PickerResetWrapper = /*#__PURE__*/React.forwardRef(function PickerResetWrapper(_ref, ref) {
  var resetable = _ref.resetable,
      className = _ref.className,
      style = _ref.style,
      disabled = _ref.disabled,
      onReset = _ref.onReset,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Row, _extends({
    wrap: false,
    className: cn(classes.root, className),
    style: style,
    ref: ref
  }, props), children, resetable && /*#__PURE__*/React.createElement(Button, {
    component: "span",
    className: cn(classes.resetButton, _defineProperty({}, classes.resetButtonDisabled, disabled)),
    size: "md",
    disabled: disabled,
    onClick: onReset
  }, /*#__PURE__*/React.createElement(Icon, {
    svg: BtnReset,
    width: 16,
    height: 16
  })));
});
PickerResetWrapper.defaultProps = {
  resetable: false,
  className: undefined,
  style: undefined,
  disabled: false
};
PickerResetWrapper.propTypes = {
  resetable: PropTypes.bool,
  onReset: PropTypes.func.isRequired,
  className: PropTypes.string,
  style: PropTypes.shape(),
  disabled: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};
PickerResetWrapper.displayName = 'PickerResetWrapper';
export default PickerResetWrapper;